/* @jsx mdx */
import React from 'react';
import { mdx } from '@mdx-js/react'
/* @jsx mdx */
import { ShaderVaryings } from './InteractiveComponents';
export const metadata = {
  demo: ShaderVaryings,
  title: 'UV Coordinates'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`You can pass data down from the vertex to the fragment shader using `}<em parentName="p">{`varyings`}</em>{`. These have to be declared with the same name and type in both vertex and fragment shaders.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
